import React,{useEffect, useState} from 'react';
import Header from  '../mini-components/Header';
import Singleinput from '../mini-components/Singleinput'
import Footer from  '../mini-components/Footer';
// import Verify from '../mini-components/Verify';
import {useHistory,useParams} from 'react-router-dom';

const Sms = () => {
    const url = window.location.href;
    const {refId, perPhoneOne} = useParams();

    const history =  useHistory();
    const [ userData, setUserData ] = useState();

    // Fetching  verify page
   
    const callAboutPage = async()=>{
        try {
        const res = await  fetch(`/sendsms/${refId}/${perPhoneOne}`,{
            method:'GET',
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json',
                
            },
            credentials:"include"
            
        });
        const data = await res.json();
        console.log("the passing data is:", data);
        setUserData(data);
        if(!res.status === 200 ){
            const error = new Error(res.error);
            throw error;
        }
        history.push(`/verify?refId=${data[0].referenceNumber}&perPhoneOne=${data[0].perPhoneOne}`)
        } catch (error) {
            console.log("this is error part:",error)
            // history.push('/signin')
        }
    }
    
   useEffect(() => {
    //first load when this page is loaded
      callAboutPage();
       
   }, [])


    return (
        <div>
            <Header/>
            <div className="form-wrapper section-padding">
               <div className="container">
                   <div className="row">
                       <div className="col-md-8 col-lg-8 offset-md-2 offset-lg-2">
                         <h2 className="text-center">SMS SENT</h2>
                         
                       </div>
                   </div>
               </div>
            </div>
            <Footer/>
        </div>
    )
}

export default Sms;
